export const VALIDATION_RULES = [{ required: true, message: "Please enter value" }];

export const validFilters = ["teamMember", "teamDepot"];
